<template>
  <a class="fa fa-question-circle popover-help" v-bind:style="customStyle" v-bind:class="class"
    tabindex="0"
    role="button"
    data-placement="{{placement}}"
    data-html="true"
    data-trigger="focus"
    data-container="body"
    title="Help"
    data-content="{{{message}}}"
  ></a>
</template>

<script>
  export default {
    props: {
      message: {
        required: true
      },
      style: {
        required: false,
        default: ''
      },
      placement: {
        required: false,
        default: 'left'
      },
      class: {
        required: false
      }
    },

    computed: {
      customStyle() {
        return `'margin-left: 7px; margin-top: 10px; ${this.style}'`;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// quote.vue?25f898fa